import React, { useEffect } from "react"
// import React, { useEffect, useState } from "react"  // BANK PAYMENTS DISABLED - useState needed when re-enabled
import { useNavigate } from "react-router-dom"
// import { Product } from "./types"  // BANK PAYMENTS DISABLED
import LoadingPlaceholder from "./components/LoadingPlaceholder"
import useAuthListener from "./utils/authListener"
// import LaunchLink from "./components/LaunchLink"
import useOrders from "./services/orders"
// import ProductView from "./components/ProductView"
import Footer from "./Footer"
// import LegalNameAndEmailForm from "./components/LegalNameForm"
// import { useLink } from "./services"
// import { debugPrint, logAnalyticsEvent } from "./utils/helpers"  // BANK PAYMENTS DISABLED
import { useUserData } from "./services/userData"
// import { ReactComponent as ConnectedIcon } from "./assets/images/connected.svg"
import { ReactComponent as BoxIcon } from "./assets/images/box.svg"
// import { ReactComponent as InfoIcon } from "./assets/images/info.gold.svg"
import { parseIcon } from "./utils"
// import AccountsList from "./components/AccountsList"


// BANK PAYMENTS DISABLED - Uncomment to re-enable
/// When changing prices make sure to update the Firebase Function that creates
/// transfers. This function sets the transfer metadata 'plan' attribute based
/// on the price.
// const PRODUCTS: Product[] = [
//     { id: 1, name: 'Triumph Monthly', price: 1000 },
//     { id: 2, name: 'Standard Monthly', price: 500 },
//     { id: 3, name: 'Triumph Weekly', price: 300 },
//     { id: 4, name: 'Standard Weekly', price: 150 },
// ]

export default function Dashboard(): JSX.Element {
    const navigate = useNavigate()
    const { uid } = useAuthListener()
    const { fetchUserData, userData } = useUserData()
    // BANK PAYMENTS DISABLED - Uncomment to re-enable
    // const { fetchUserData, setDefaultAccount, removeAccount, userData } = useUserData()
    const { hasLoaded, orders } = userData
    // BANK PAYMENTS DISABLED - Uncomment to re-enable
    // const { accountBeingDeleted, accounts, defaultAccount, email, hasLoaded, legalName, orders } = userData
    // const [localError, setLocalError] = useState<string | null>(null)
    // const [selectedProduct, setSelectedProduct] = useState<Product>(PRODUCTS[0])
    const { orderErrorMessage } = useOrders()
    // BANK PAYMENTS DISABLED - Uncomment to re-enable
    // const { orderErrorMessage, placeOrder } = useOrders()
    // const [placingOrder, setPlacingOrder] = useState(false)
    // const [linkActivity, setLinkActivity] = useState(false)
    // const [token, setToken] = useState<string | null>(null)
    // const { linkTokens, generateLinkToken } = useLink()

    // BANK PAYMENTS DISABLED - Uncomment to re-enable
    // const initiateLink = async () => {
    //     setLinkActivity(true)
    //     await generateLinkToken(uid, null)
    //     setLinkActivity(false)
    // }

    // BANK PAYMENTS DISABLED - Uncomment to re-enable
    // const initiateLinkInUpdateMode = async (itemId: string) => {
    //     setLinkActivity(true)
    //     await generateLinkToken(uid, itemId)
    //     setLinkActivity(false)
    // }

    // BANK PAYMENTS DISABLED - Uncomment to re-enable
    // const orderButtonHandler = async () => {
    //     try {
    //         setPlacingOrder(true)
    //         const orderId = await placeOrder({ name: selectedProduct.name, amount: selectedProduct.price })
    //         if (orderId)
    //             navigate(`/orders/${orderId}`)
    //     } catch (error) {
    //         debugPrint(JSON.stringify(error), 'error')
    //         logAnalyticsEvent({ type: 'server-error', message: `placeOrder for (${selectedProduct.name}, ${selectedProduct.price}) failed with error: ` + JSON.stringify(error) })
    //         setLocalError("An internal server error has occurred. Please contact support if the issue persists.")
    //     }
    //     setPlacingOrder(false)
    // }

    useEffect(() => {
        fetchUserData(uid)
    }, [uid])

    // BANK PAYMENTS DISABLED - Uncomment to re-enable
    // useEffect(() => {
    //     if (linkTokens.byUser) {
    //         debugPrint(`linkTokens.byUser: ${JSON.stringify(linkTokens.byUser)}`, 'info')
    //         setToken(linkTokens.byUser)
    //     } else if (linkTokens.byItem) {
    //         debugPrint(`linkTokens.byItem: ${JSON.stringify(linkTokens.byItem)}`, 'info')
    //         setToken(linkTokens.byItem)
    //     } else {
    //         setToken(null)
    //     }
    // }, [linkTokens])


    // BANK PAYMENTS DISABLED - Uncomment to re-enable
    // checks local storage for 'plan'.
    // Removes the saved value after it is used.
    // useEffect(() => {
    //     const plan = localStorage.getItem('plan')
    //     if (plan) {
    //         switch (plan) {
    //             case 'Triumph 1 Month - $1000':
    //                 setSelectedProduct(PRODUCTS[0])
    //                 break
    //             case 'Standard 1 Month - $500':
    //                 setSelectedProduct(PRODUCTS[1])
    //                 break
    //             case 'Triumph 1 Week - $300':
    //                 setSelectedProduct(PRODUCTS[2])
    //                 break
    //             case 'Standard 1 Week - $150':
    //                 setSelectedProduct(PRODUCTS[3])
    //                 break
    //             default:
    //                 setSelectedProduct(PRODUCTS[0])
    //                 logAnalyticsEvent({ type: 'config-error', message: `Unhandled plan in localStorage: ${plan}` })
    //                 debugPrint(`🙋‍♂️ Unhandled plan: ${plan}`, 'warn')
    //                 break
    //         }
    //         localStorage.removeItem('plan')
    //     }
    // }, [])

    const navigateToOrder = (ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
        const orderId = ev.currentTarget.getAttribute('data-order-id')
        navigate(`/orders/${orderId}`)
    }

    const ordersView = (): JSX.Element => {
        const ordersList = Object.keys(orders).map((key) => orders[key])
        return <tbody>
            {ordersList.sort((a, b) => b.timestamp - a.timestamp).map((order) => (
                <tr key={order.id} data-order-id={order.id} onClick={navigateToOrder} role="button">
                    <td>{prettyDate(order.timestamp)}</td>
                    <td>{order.plan}</td>
                    <td style={{ textTransform: 'capitalize' }}>{parseIcon(order.status)} {order.status}</td>
                </tr>
            ))}
        </tbody>
    }

    const prettyDate = (timestamp: number) => new Date(timestamp).toLocaleDateString()

    // BANK PAYMENTS DISABLED - Uncomment to re-enable
    // const productsView = (): JSX.Element => {
    //     return <div className="row d-flex flex-row">
    //         {PRODUCTS.map((product) => <ProductView
    //             key={product.id}
    //             isSelected={product.id === selectedProduct.id}
    //             product={product}
    //             selectHandler={setSelectedProduct}
    //         />)}
    //     </div>
    // }
    // const hasAccounts = Object.keys(accounts).length > 0

    if (!hasLoaded) return <LoadingPlaceholder />

    const errorMessage = orderErrorMessage ?? ""

    return (
        <div id="dashboard" className="d-flex flex-column" style={{ minHeight: '100vh' }}>
            <div className="container my-4 flex-grow-1 flex-column">
                {!!(errorMessage) && <div className='alert alert-danger text-center mx-auto'>{errorMessage}</div>}

                {/* Bank Payments Discontinued Notice */}
                <section className="mb-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-xl-7">
                            <div className="text-center py-5 px-4" style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                borderRadius: '12px',
                                border: '1px solid rgba(255, 255, 255, 0.18)'
                            }}>
                                <h3 className="mb-4" style={{ color: 'var(--pp-gold)' }}>Bank Payments Update</h3>

                                <ul className="list-unstyled text-start mb-4 mx-auto" style={{ maxWidth: '320px' }}>
                                    <li className="mb-3 d-flex align-items-start">
                                        <span className="me-3" style={{ color: 'var(--pp-gold)' }}>✓</span>
                                        <span>Bank payments have been discontinued</span>
                                    </li>
                                    <li className="mb-3 d-flex align-items-start">
                                        <span className="me-3" style={{ color: 'var(--pp-gold)' }}>✓</span>
                                        <span>Your connected accounts have been securely removed</span>
                                    </li>
                                    <li className="mb-3 d-flex align-items-start">
                                        <span className="me-3" style={{ color: 'var(--pp-gold)' }}>✓</span>
                                        <span>Your order history remains available below</span>
                                    </li>
                                </ul>

                                <p className="text-subtle mb-4">To purchase a plan, please visit our payment options page.</p>

                                <a
                                    href="https://www.parlayp.com/payment-options/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary btn-lg px-5 py-2 fs-5"
                                    style={{ borderRadius: '50px' }}
                                >
                                    View Payment Options
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {(Object.keys(orders).length > 0) &&
                    <section className="d-flex flex-grow-1 flex-column">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-xl-7">
                                <div className="py-4 px-4" style={{
                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                    borderRadius: '12px',
                                    border: '1px solid rgba(255, 255, 255, 0.18)'
                                }}>
                                    <h3 className="mb-3"><BoxIcon /> Your Orders</h3>
                                    <table className="table table-hover table-orders mb-0">
                                        <thead>
                                            <tr>
                                                <th scope="col">Date</th>
                                                <th scope="col">Plan</th>
                                                <th scope="col">Status</th>
                                            </tr>
                                        </thead>
                                        {ordersView()}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                }

            </div>
            <Footer />
        </div>
    )
}
